import angular from 'angular';
import { Storage } from './Storage';
import { ObjectStorageEngine } from './ObjectStorageEngine.js';

angular.module('sh.storage', []).constant('storage', getLocalStorage()).constant('tempStorage', getSessionStorage());

//In the boomarklet the page was blank because of a "Failed to read 'localStorage' from 'Window': Access denied for this document" error.
function getLocalStorage() {
	try {
		return new Storage(localStorage);
	} catch (e) {
		return new Storage(new ObjectStorageEngine());
	}
}
function getSessionStorage() {
	try {
		return new Storage(sessionStorage);
	} catch (e) {
		return new Storage(new ObjectStorageEngine());
	}
}
